import React from 'react';
import { cn } from '../../../lib/utils';

interface AnimatedShinyTextProps {
  children: React.ReactNode;
  className?: string;
  shimmerWidth?: number;
}

export const AnimatedShinyText: React.FC<AnimatedShinyTextProps> = ({
  children,
  className,
  shimmerWidth = 100,
}) => {
  return (
    <span
      style={{ '--shiny-width': `${shimmerWidth}px` } as React.CSSProperties}
      className={cn(
        'text-slate-800/70',
        'animate-shiny-text bg-clip-text bg-no-repeat [background-position:0_0] [background-size:var(--shiny-width)_100%]',
        'bg-gradient-to-r from-transparent via-[#003b82]/80 via-50% to-transparent',
        className
      )}
    >
      {children}
    </span>
  );
};
